// Texts of the local SERP checker page. The English version is written for US
// search (target keywords: "local serp checker", "google search from different
// location"), not translated word for word. The French page has no guide.
const content = {
  fr: {
    seo: {
      title: "Analyser les résultats Google localisés | Localranker",
      description:
        "Vous vous demandez si vous êtes bien référencé dans une certaine localisation ? Vérifiez cela avec notre outil gratuit !",
    },
    hero: {
      title: "Analyser les resultats de recherche locale",
      subtitle:
        "Découvrez en un clin d'oeil les résultats de recherche Google de façon hyper localisé",
      cta: "Lancer mon analyse",
    },
    loading: "♻️ Récupération des données",
    modalTitle: "Encore une petite étape",
    guide: null,
  },
  en: {
    seo: {
      title: "Local SERP Checker: Search Google From Any Location | Localranker",
      description:
        "Free local SERP checker: search Google from a different location and see the Google Search and Google Maps results for any city or ZIP code, page by page.",
    },
    hero: {
      title: "Local SERP Checker",
      subtitle:
        "See Google Search and Google Maps results as if you were searching from any city or ZIP code.",
      cta: "Check local results",
    },
    loading: "♻️ Fetching the data",
    modalTitle: "One more step",
    guide: {
      sections: [
        {
          title: "How to search Google from a different location",
          paragraphs: [
            "Type the keyword you want to check, enter a city, a ZIP code or a full address, pick the country and choose between Google Search and Google Maps.",
            "The tool turns your location into Google's location parameter and gives you links to the first 10 pages of results. Each link opens Google as if you were searching from that place, in a non-personalized session, so your own location and search history don't skew the rankings.",
          ],
        },
        {
          title: "Why check local search results from another location?",
          paragraphs: [
            "Google ranks local results by proximity: the same search for \"plumber\" or \"coffee shop\" returns different businesses a few blocks away. If you manage several locations, or work with clients in other cities, you can't see their real rankings from your desk.",
            "A local search checker shows you what customers near each location actually see: whether your business shows up in the Map Pack, which competitors outrank you, and how results change from one neighborhood to the next.",
          ],
        },
      ],
      faqTitle: "Frequently asked questions",
      faq: [
        {
          question: "Can I see Google Maps results for another city?",
          answer:
            "Yes. Choose \"Maps\" as the search type and the links open Google's local results for the location you entered, so you can see which businesses rank for that keyword there.",
        },
        {
          question: "Why are the results different from what I see on my phone?",
          answer:
            "Your own searches are influenced by your exact GPS position, your search history and your Google account. The links from this tool remove personalization and use the location you entered instead.",
        },
        {
          question: "Is this local SERP checker free?",
          answer:
            "Yes, it's free. To track rankings for many keywords and locations over time, Localranker offers rank tracking for multi-location businesses.",
        },
      ],
    },
  },
};

export default content;
